import { render, staticRenderFns } from "./VideoLibrary.vue?vue&type=template&id=4a73ace8&scoped=true&"
import script from "./VideoLibrary.vue?vue&type=script&lang=js&"
export * from "./VideoLibrary.vue?vue&type=script&lang=js&"
import style0 from "./VideoLibrary.vue?vue&type=style&index=0&id=4a73ace8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a73ace8",
  null
  
)

export default component.exports